import styled from 'styled-components'

import { colors } from 'themes'

interface ConfirmButtonProps {
	disabled?: boolean
}

export const ConfirmButton = styled.div<ConfirmButtonProps>`
	padding: 20px 35px;
	border-radius: 11px;
	
	${({ disabled }) => disabled ? `
		pointer-events: none;
		opacity: 0.3;
	` : ''};
	
	background: ${colors.confirmButton.background};
	color: ${colors.confirmButton.text};
	&.gray {
		background: ${colors.confirmButton.grayBackground};
	}
	&.red {
		background: ${colors.confirmButton.redBackground};
	}
	&.white {
		background: ${colors.confirmButton.whiteBackground};
		color: ${colors.confirmButton.whiteText};
	}
	&.green {
		background: ${colors.confirmButton.greenBackground};
		color: ${colors.confirmButton.greenText};
	}
	
	box-shadow: ${colors.confirmButton.boxShadow};
	font-weight: bold;
	text-align: center;
	align-self: center;
	
	font-size: 1.14em;
	line-height: 1.14em;
	
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
	
	:hover {
		transform: scale(1.01);
		opacity: 0.9;
	}
	transition: 200ms ease;
`
